/**
 * AttentionManagerAction (KAN-828)
 *
 * Выбор менеджера в строке блока "Требуют внимания": менеджер клиента
 * меняется прямо в строке ("Без менеджера" снимает его), строка остаётся в
 * блоке. Если клиент за другим менеджером и менять нельзя, выбор недоступен
 * с подсказкой. KAN-852: отдельной кнопки "Взять себе" нет: менеджер берёт
 * клиента кнопкой "Взять в работу" (строка уходит из внимания).
 * Состояние и права приходят из useAttentionManager строки (AttentionRowActions),
 * чтобы на время сохранения блокировать и кнопки закрытия. Не показывается,
 * если менять менеджера нельзя совсем (KAN-811 api_access).
 */
import { ManagerSelect } from '@/components/managers/ManagerSelect'
import type { AttentionItem } from '@/services/api/dashboard'
import { NO_MANAGER_OPTION } from './AttentionDoneDialog'
import type { AttentionManager } from './useAttentionManager'

interface AttentionManagerActionProps {
  item: Pick<AttentionItem, 'manager'>
  manager: AttentionManager
  /** Идёт запрос закрытия строки. */
  disabled?: boolean
}

export function AttentionManagerAction({ item, manager, disabled = false }: AttentionManagerActionProps) {
  if (!manager.canAssign) return null
  return (
    <div className="flex max-w-full items-start gap-2" data-testid="attention-manager">
      {/* KAN-965: узкий низкий выбор, стоит в одном ряду с кнопками строки. */}
      <div className="w-40 max-w-full">
        <ManagerSelect
          value={item.manager ?? null}
          onSelect={manager.assign}
          disabled={disabled || !manager.canChange}
          pending={manager.pending}
          error={manager.error}
          noneLabel={NO_MANAGER_OPTION}
          testId="attention-manager-select"
          compact
        />
        {manager.lockedHint && (
          <p className="mt-0.5 text-xs text-gray-500" data-testid="attention-manager-locked">
            {manager.lockedHint}
          </p>
        )}
      </div>
    </div>
  )
}
